import { createSlice } from '@reduxjs/toolkit'

interface Folder {
  id: number
  name: string
}

interface FoldersState {
  loading: boolean
  folders: Folder[]
  menuFolders: {
    label: string
    value: number
  }[]
}

const initialState: FoldersState = {
  loading: true,
  folders: [],
  menuFolders: [],
}

export const folders = createSlice({
  name: 'folders',
  initialState,
  reducers: {
    all(state, action: { payload: Folder[] }) {
      return {
        ...state,
        loading: false,
        folders: action.payload,
        menuFolders: action.payload.map(fold => ({ label: fold.name, value: fold.id })),
      }
    },
    updateFolder(state, action: { payload: Folder }) {
      const index = state.folders.findIndex(f => f.id === action.payload.id)
      const newFolders = state.folders.slice()
      newFolders.splice(index, 1, action.payload)
      return {
        ...state,
        folders: newFolders,
      }
    },
    added(state, action: { payload: Folder }) {
      const folderAdded = action.payload
      return {
        ...state,
        folders: [...state.folders.slice(), folderAdded],
        menuFolders: [
          ...state.menuFolders.slice(),
          { label: folderAdded.name, value: folderAdded.id },
        ], // anit-pattern should make this be a useEffect in the component consuming
      }
    },
    updated(state, action: { payload: Folder[] }) {
      return {
        ...state,
        loading: false,
        folders: action.payload,
        menuFolders: action.payload.map(fold => ({ label: fold.name, value: fold.id })),
      }
    },
    deleted(state, action: { payload: number }) {
      const deletedId = action.payload
      return {
        ...state,
        folders: state.folders.filter(({ id }) => id != deletedId),
        menuFolders: state.menuFolders.filter(({ value }) => value != deletedId),
      }
    },
  },
})
